export enum PermissionSection {
    DASHBOARD_GROUP = 'DashboardGroupView',
    DASHBOARD_SITE = 'DashboardSiteView',
    REALTIME = 'RealtimeView',
    CONSTRAINTS = 'ConstraintsView',
    DOCUMENTS = 'DocumentsView',
    CONTACTS = 'ContactsView',
}

export enum PermissionType {
    READ = 'Read',
    EDIT = 'Edit',
    MANAGE = 'Manage',
}

export type UserPermission = {
    grantType: PermissionType
    hash: string
    section: PermissionSection
    siteId: string
    userId: number
    userPermissionId: string
}

export type Release = {
    releaseId: string
    title: string
    description: string
    createdAt: string
    redirectUrl?: string
    hasSeen?: boolean
    path?: string
    imageUrl?: string
    pictureUrl?: string
}
